module.exports = __webpack_public_path__ + "static/media/th1@2x.fd42f1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/th1@2x.png
// module id = 250
// module chunks = 0